import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function fetchSlaChamado(satNum) {
  const base = getBase();
  if (!base || !satNum) return null;
  try {
    const res = await axios.get(base + '/sla/chamado/' + satNum, { headers: getAuthHeaders(), timeout: 15000 });
    return res?.data ?? null;
  } catch (err) { return null; }
}

export async function fetchPoliticas() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/sla/politicas', { headers: getAuthHeaders(), timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) { return []; }
}
export async function createPolitica(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/sla/politicas', body, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function updatePolitica(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/sla/politicas/' + id, body, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function deletePolitica(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/sla/politicas/' + id, { headers: getAuthHeaders(), timeout: 15000 });
}

// Status do chamado (para o multiselect de "status que pausam o SLA").
export async function fetchStatusOpcoes() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/status-chamado', { headers: getAuthHeaders(), timeout: 15000 });
    const data = res?.data;
    const arr = Array.isArray(data) ? data : (Array.isArray(data?.status) ? data.status : []);
    return arr;
  } catch (err) { return []; }
}

export function rotuloEstadoSla(estado) {
  return { no_prazo: 'No prazo', risco: 'Em risco', violado: 'Atrasado', resolvido: 'Resolvido' }[estado] || estado;
}
export function corEstadoSla(estado) {
  return { no_prazo: 'success', risco: 'warning', violado: 'danger', resolvido: 'secondary' }[estado] || 'secondary';
}
export function horasParaTexto(h) {
  const n = Number(h) || 0;
  const horas = Math.floor(n);
  const min = Math.round((n - horas) * 60);
  if (horas && min) return `${horas}h${String(min).padStart(2, '0')}`;
  if (horas) return `${horas}h`;
  return `${min}min`;
}
